import React from "react";
import BaseComponent from "../BaseComponent";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import searchService from "../../services/SearchService.js";

import Button from "../Nano/Buttons/Button.js";
import Spinner from "../Nano/Spinner.js";
import Type from "../Global/Typography.js";
import Input from "../Nano/Input.js";
import TitleCard from "../Nano/TitleCard.js";
import Grid from "../Macro/Grid.js";
import WrapperList from "../Nano/WrapperList.js";

//IMAGES
import { ReactComponent as SearchIcon } from "../Global/Icons/search.svg";
import { ReactComponent as SavedSearch } from "../Global/Icons/savedSearches.svg";
import { ReactComponent as Check } from "../Global/Icons/check.svg";

import NotaIcon from "../Global/Icons/nota-icon.svg";

const multiple = nota.global.multiple;

const UpdateSavedSearchModalStyle = styled.div`
  width: 700px;
  background-color: ${nota.color.neutral.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: ${multiple * 3 + "px"};
  .headerModal {
    padding-bottom: ${multiple + "px"};
    border-bottom: 0.5px solid ${nota.color.neutral.NeuFour};
    svg {
      height: 16px;
      width: 16px;
      path {
        fill: ${nota.color.main.default};
      }
    }
    h3 {
      margin-left: ${multiple + "px"};
      text-transform: uppercase;
      b {
        color: ${nota.color.main.default};
      }
    }
  }
  .modalContainer {
    .modalWrapper {
      padding: ${multiple * 3 + "px"} 0;
    }
  }
  .loadingContainer {
    min-height: 406px;
  }

  /* INPUT SEARCH */
  .inputWrapper {
    width: 100%;
    position: relative;
    .inputContainer {
      width: 100%;
      margin: 0;
      input {
        padding-right: 40px;
      }
    }
    .searchIconWrapper {
      position: absolute;
      right: ${multiple + "px"};
      top: 0;
      width: ${multiple * 3 + "px"};
      svg {
        width: 18px;
        height: 18px;
        path {
          fill: ${nota.color.main.default};
        }
      }
    }
  }

  .btnsContainer {
    padding: 16px 8px 0 8px;
    border-top: 0.5px solid ${nota.color.neutral.NeuFour};
    .cta {
      margin: 0;
    }
  }

  .dropDownWrapper {
    .dropdown-content {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }

  /* LIST */
  .list {
    margin-top: ${multiple + "px"};
    max-height: 466px;
    overflow: auto;
    padding: ${multiple + "px"};
    background: ${nota.color.neutral.lightGrey};
    min-height: 264px;
    background-image: url(${NotaIcon});
    background-repeat: no-repeat, repeat;
    background-size: 50% 50%;
    background-position: center;
  }
  .listContainer {
    height: auto;

    .itemContainer {
      width: 100%;
      height: auto;
      margin-bottom: ${multiple / 2 + "px"};
      .selectItem {
        width: ${multiple * 5 + "px"};
        height: auto;
        background-color: ${nota.color.neutral.NeuFour};
        cursor: pointer;
        border-right: 1px solid ${nota.color.neutral.NeuFive};
        .iconContainer {
          svg {
            width: 16px;
            height: 20px;
            path {
              fill: ${nota.color.neutral.NeuTwo};
            }
          }
        }
        &:hover {
          opacity: 0.7;
        }
      }
      .wrapperList {
        padding: 0;
        margin: 0;
        border: 1px solid ${nota.color.neutral.NeuFour};
        box-shadow: none;

        .headerContainer {
          height: auto;
        }
        .titleCard {
          margin-top: ${multiple * 2 + "px"};
          margin-left: ${multiple * 2 + "px"};
          margin-bottom: ${multiple / 2 + "px"};
          width: 85%;
          height: auto;
          h3 {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        .descriptionWrapper {
          margin-left: ${multiple * 2 + "px"};
          margin-bottom: ${multiple + "px"};
          width: 85%;
          height: auto;
          p {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        .noInfo {
          margin-bottom: ${multiple + "px"};
          font-size: 12px;
          color: ${nota.color.neutral.NeuThree};
          line-height: unset;
          height: auto;
        }

        .gridContainer {
          height: 145px;
          .emptyGrid {
            background-color: ${nota.color.neutral.NeuFour};
            padding: 16px;
            p {
              text-transform: uppercase;
            }
          }
        }
        .grid {
          padding: 0 ${multiple + "px"};
          grid-template-columns: repeat(auto-fill, minmax(125px, 1fr));
        }
        .bottomOptionsWrapper {
          padding: ${multiple + "px"} ${multiple * 2 + "px"};
          background-color: ${nota.color.neutral.lightGrey};
        }
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
    .selectedItem {
      .selectItem {
        background-color: ${nota.color.main.default};
        border-right: 1px solid ${nota.color.main.default};
        .iconContainer {
          svg {
            path {
              fill: ${nota.color.neutral.white};
            }
          }
        }
      }
      .wrapperList {
        border: 1px solid ${nota.color.main.default};
      }
    }
  }

  @media only screen and (max-width: ${nota.global.breakpoints.tablet + "px"}) {
    .list {
      max-height: 344px;
    }
  }

  @media only screen and (max-width: 720px) {
    width: 90vw;
  }
  @media only screen and (max-width: 520px) {
    .modalContainer {
      .btnsContainer {
        flex-direction: column;
        height: auto;

        .buttonWrapper {
          order: 1;
        }
        .simpleButtonWrapper {
          order: 2;
          margin-top: 8px;
        }
      }
    }
  }

  @media only screen and (max-width: 420px) {
    .listContainer {
      .itemContainer {
        .wrapperList {
          .gridContainer {
            height: auto;
          }
          .bottomOptionsWrapper {
            flex-direction: column;
            padding-left: 11px;
          }
        }
      }
    }
  }

  @media only screen and (max-height: 630px) {
    .list {
      max-height: 42vh;
      min-height: 42vh;
    }
  }
`;

export class SavedSearchItem extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      programs: null,
      count: null,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onSavedSearchItemLanguageChange, false);

    this.getAllData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.requestId !== this.props.requestId) {
      this.getPrograms();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onSavedSearchItemLanguageChange, false);
  }

  onSavedSearchItemLanguageChange = () => {
    this.getAllData();
  };

  getAllData = () => {
    this.getPrograms();
  };

  getPrograms = () => {
    if (this.props.savedSearch.filter) {
      searchService
        .getAdvancedSearchPrograms({ ...this.props.savedSearch.filter, ...{ Page: 1, ResultsPerPage: 7, SearchFrom: "SavedSearch" } })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          this.setState({ programs: data.programs, count: data.count });
        });
    } else {
      this.setState({ programs: [] });
    }
  };

  canShow = () => {
    if (this.props.term.trim() !== "") {
      let upperTerm = this.props.term.trim().toUpperCase();
      let upperName = this.props.savedSearch.searchName.trim().toUpperCase();
      return upperName.startsWith(upperTerm);
    }
    return true;
  };

  selectedChange = () => {
    this.props.onSelectedChange(this.props.savedSearch.id);
  };

  render() {
    if (this.canShow() == false) return null;

    return (
      <NanoFlex className={`itemContainer ${this.props.selected ? "selectedItem" : ""}`}>
        <NanoFlex className="wrapperListContainer" flexDirection={"row"} alignItems={"stretch"}>
          <NanoFlex className="selectItem" alignItems={"stretch"} onClick={this.selectedChange}>
            <NanoFlex className="iconContainer">
              <Check />
            </NanoFlex>
          </NanoFlex>

          <NanoFlex flexDirection={"column"} justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
            <WrapperList className="wrapperList">
              <NanoFlex className="headerContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                <NanoFlex className="titleCard" justifyContent={"flex-start"}>
                  <Type.h3 title={this.props.savedSearch.searchName}>
                    <b>{this.props.savedSearch.searchName}</b>
                  </Type.h3>
                </NanoFlex>
                <NanoFlex className="descriptionWrapper" justifyContent={"flex-start"}>
                  {this.props.savedSearch.description && <Type.p title={this.props.savedSearch.description}>{this.props.savedSearch.description}</Type.p>}
                  {!this.props.savedSearch.description && <Type.p className="noInfo">{this.translation.geral.noDescription}</Type.p>}
                </NanoFlex>
              </NanoFlex>

              <NanoFlex className="gridContainer">
                {this.state.programs?.length > 0 && <Grid className="gridItem" data={this.state.programs} row={1} />}

                {this.state.programs?.length == 0 && (
                  <NanoFlex className="emptyGrid">
                    <Type.p>No items</Type.p>
                  </NanoFlex>
                )}

                {!this.state.programs && (
                  <NanoFlex className="loagindGrid">
                    <Spinner />
                  </NanoFlex>
                )}
              </NanoFlex>
              <NanoFlex className="bottomOptionsWrapper">
                <NanoFlex justifyContent={"flex-start"}>
                  <Type.p>{this.props.savedSearch.updateDate}</Type.p>
                </NanoFlex>
                <NanoFlex justifyContent={"flex-start"}>
                  <Type.p>
                    {this.state.count ?? "-"} {this.state.count > 1 ? this.translation.geral.programmes : this.translation.geral.programme}
                  </Type.p>
                </NanoFlex>
              </NanoFlex>
            </WrapperList>
          </NanoFlex>
        </NanoFlex>
      </NanoFlex>
    );
  }
}

class UpdateSavedSearchModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      term: "",
      loading: true,
      savedSearches: [],
      selectedSavedSearch: null,
      requestId: 0,
    };
  };

  componentDidMount() {
    super.componentDidMount();
    if (this.props.visible) this.getComponentData();

    window.addEventListener("saveSearch", this.onSavedSearchChange, false);
    window.addEventListener("languageChange", this.onUpdateSavedSearchLanguageChange, false);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible !== this.props.visible && this.props.visible && this.state.loading) this.getComponentData();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("saveSearch", this.onSavedSearchChange, false);
    window.removeEventListener("languageChange", this.onUpdateSavedSearchLanguageChange, false);
  }

  onUpdateSavedSearchLanguageChange = () => {
    if (this.state.loading === false) this.getSavedSearches();
  };

  onSavedSearchChange = () => {
    this.getSavedSearches();
  };

  getComponentData = () => {
    this.getSavedSearches();
  };

  getSavedSearches = () => {
    searchService
      .getSavedSearches()
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        if (this.props.savedSearchLoadAction) {
          this.props.savedSearchLoadAction(data);
        }
        this.setState({
          savedSearches: data,
          loading: false,
          requestId: this.state.requestId + 1,
        });
      });
  };

  onTermChange = (value) => {
    this.setState({ term: value });
  };

  updateSavedSearch = () => {
    this.setState({ loading: true }, () => {
      searchService
        .saveSearchFilter({
          Id: this.state.selectedSavedSearch,
          Filter: this.props.filter,
        })
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          this.setState({ loading: false, selectedSavedSearch: null }, () => {
            this.getSavedSearches();
            window.dispatchEvent(new Event("saveSearch"));
            /*Reload Navbar SavedSearches*/
            window.dispatchEvent(new Event("reloadNavbarSavedSearches"));
            this.props.nextAction();
          });
        });
    });
  };

  cancelUpdateSavedSearch = () => {
    this.setState({ selectedSavedSearch: null }, () => {
      this.props.cancelAction();
    });
  };

  onSelectedChange = (id) => {
    if (this.state.selectedSavedSearch !== id) {
      this.setState({ selectedSavedSearch: id });
    } else {
      this.setState({ selectedSavedSearch: null });
    }
  };

  render() {
    return (
      <UpdateSavedSearchModalStyle>
        <NanoFlex className="headerModal" justifyContent="flex-start">
          <SavedSearch />
          <Type.h3>
            <b>{this.translation.savedSearch.updateSavedSearch}</b>
          </Type.h3>
        </NanoFlex>
        {this.state.loading && (
          <NanoFlex className="loadingContainer">
            <Spinner />
          </NanoFlex>
        )}
        {!this.state.loading && (
          <NanoFlex className="modalContainer" flexDirection={"column"} justifyContent="space-between" alignContent="space-between">
            <NanoFlex className="modalWrapper" flexDirection={"column"}>
              <NanoFlex className="inputWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
                <Input title={null} defaultValue={this.state.term} placeholder={this.translation.savedSearch.searchSavedSearchPlaceholder} onChangeAction={this.onTermChange} />
                <NanoFlex className="searchIconWrapper">
                  <SearchIcon />
                </NanoFlex>
              </NanoFlex>

              <NanoFlex className="list" justifyContent={"flex-start"} alignItems={"flex-start"}>
                {/*LIST*/}
                <NanoFlex className="listContainer" flexDirection={"column"}>
                  {/* ITEM  */}
                  {this.state.savedSearches &&
                    this.state.savedSearches.map((item) => {
                      return <SavedSearchItem savedSearch={item} key={item.id} requestId={this.state.requestId} term={this.state.term} selected={this.state.selectedSavedSearch === item.id} onSelectedChange={this.onSelectedChange}></SavedSearchItem>;
                    })}
                  {/* END ITEM  */}
                </NanoFlex>
                {/* END LIST  */}
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="btnsContainer" alignContent={"flex-end"}>
              <Button label={this.translation.geral.cancel} simple clickAction={this.cancelUpdateSavedSearch} />
              <Button label={this.translation.geral.confirm} disable={this.state.selectedSavedSearch === null} clickAction={this.updateSavedSearch} />
            </NanoFlex>
          </NanoFlex>
        )}
      </UpdateSavedSearchModalStyle>
    );
  }
}

// Set default props
UpdateSavedSearchModal.defaultProps = {
  cancelAction: () => null,
  nextAction: () => null,
};

export default UpdateSavedSearchModal;

/*
Doc
import UpdateSavedSearchModal from '../../Micro/UpdateSavedSearchModal.js';

<UpdateSavedSearchModal
    cancelAction={() => console.log('cancelAction')}
    nextAction={() => console.log('nextAction')}
/>
*/
